/*
 * <product-media-overlay>: keeps the "1 / N" counter on the PDP gallery in step with the image.
 * Desktop shows one slide at a time and switches it via thumbnails (`is-active` on the
 * thumbnail); mobile is a horizontal scroller, so the counter follows its scroll position.
 */
if (!customElements.get('product-media-overlay')) {
  customElements.define(
    'product-media-overlay',
    class ProductMediaOverlay extends HTMLElement {
      connectedCallback() {
        this.current = this.querySelector('[data-current]');
        this.total = this.querySelector('[data-total]');
        const gallery = this.closest('media-gallery');
        this.list = gallery?.querySelector('.product__media-list');
        this.thumbnails = gallery?.querySelector('.thumbnail-list');
        if (!this.current || !this.list) return;

        this.update = this.update.bind(this);
        this.list.addEventListener('scroll', this.update, { passive: true });
        if (this.thumbnails) {
          this.observer = new MutationObserver(this.update);
          this.observer.observe(this.thumbnails, { subtree: true, attributeFilter: ['class'] });
        }
        this.update();
      }

      disconnectedCallback() {
        this.list?.removeEventListener('scroll', this.update);
        this.observer?.disconnect();
      }

      update() {
        const position = this.scrolledPosition() ?? this.thumbnailPosition();
        if (!position) return;
        this.current.textContent = position.index;
        this.total.textContent = position.total;
      }

      // Mobile: several slides laid out side by side; pick the one nearest the scroll position.
      scrolledPosition() {
        const slides = [...this.list.querySelectorAll(':scope > [id^="Slide-"]')].filter((slide) => slide.offsetWidth > 0);
        if (slides.length < 2) return null;

        const left = this.list.scrollLeft;
        const distance = (slide) => Math.abs(slide.offsetLeft - left);
        const nearest = slides.reduce((a, b) => (distance(b) < distance(a) ? b : a));
        return { index: slides.indexOf(nearest) + 1, total: slides.length };
      }

      // Desktop: one slide at a time, chosen via the thumbnails (variant-hidden ones skipped).
      thumbnailPosition() {
        if (!this.thumbnails) return null;
        const visible = [...this.thumbnails.children].filter((item) => item.offsetParent !== null);
        const index = visible.findIndex((item) => item.classList.contains('is-active'));
        return index < 0 ? null : { index: index + 1, total: visible.length };
      }
    }
  );
}
